import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/copyright.vue
var s = {
	name: "DtIconCopyright",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--copyright"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Copyright",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor",
		"fill-rule": "evenodd",
		"clip-rule": "evenodd"
	}, [...t[0] || (t[0] = [i("path", { d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" }, null, -1), i("path", { d: "M5.116 3.662a2.5 2.5 0 0 1 2.759.684.5.5 0 1 1-.75.662 1.5 1.5 0 1 0 0 1.984.5.5 0 1 1 .75.662 2.5 2.5 0 1 1-2.759-3.992Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=copyright.js.map